import React, { useState, useEffect } from 'react';
import { Mail, Phone, MapPin, Calendar, Send, Building, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    startupName: '',
    phone: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);

  // Booking state
  const [slots, setSlots] = useState([]);
  const [showBooking, setShowBooking] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [bookingData, setBookingData] = useState({
    name: '',
    email: '',
    phone: '',
    startup_name: '',
    notes: ''
  });
  const [bookingSubmitting, setBookingSubmitting] = useState(false);
  const [bookingConfirmed, setBookingConfirmed] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleBookingChange = (e) =>
    setBookingData({ ...bookingData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.post(
        'https://formsubmit.co/ajax/singh.arshdeep1084@gmail.com',
        {
          name: formData.name,
          email: formData.email,
          startup_name: formData.startupName,
          phone: formData.phone,
          message: formData.message,
          _subject: 'New FounderScale Capital Enquiry',
          _template: 'table',
          _url: 'https://founderscalecapital.com/contact'
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        }
      );

      if (!response.data?.success) {
        throw new Error(
          response.data?.message || 'Failed to submit'
        );
      }

      // Google Ads conversion tracking
      // Fires only after the enquiry has been successfully submitted
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-481172523/R7VzCNmT4voCEKu4uOUB'
        });
      }

      toast({
        title: 'Message Sent!',
        description: "We'll get back to you within 24 hours."
      });

      setFormData({
        name: '',
        email: '',
        startupName: '',
        phone: '',
        message: ''
      });

    } catch (err) {
      toast({
        title: 'Error',
        description: 'We could not send your enquiry. Please try again.',
        variant: 'destructive'
      });
    } finally {
      setSubmitting(false);
    }
  };

  const openCalendly = () => {
    window.open(
      'https://calendly.com/singh-arshdeep1084',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const offices = [
    {
      country: 'India',
      flag: '🇮🇳',
      address:
        'WeWork Galaxy, 43, Residency Road, Bengaluru, Karnataka 560025',
      gradient: 'from-orange-500 to-amber-500'
    },
    {
      country: 'United States',
      flag: '🇺🇸',
      address: '1209 Orange Street, Wilmington, Delaware 19801',
      gradient: 'from-blue-500 to-indigo-500'
    },
    {
      country: 'Canada',
      flag: '🇨🇦',
      address: '100 King Street West, Suite 5700, Toronto, ON M5X 1C7',
      gradient: 'from-red-500 to-rose-500'
    }
  ];

  const selectedDaySlots = slots.find(
    (s) => s.date === selectedDate
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">

      <section className="relative py-20 bg-gradient-to-br from-emerald-600 via-green-600 to-emerald-700 overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Let's{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-200 to-emerald-100">
                Connect
              </span>
            </h1>

            <p className="text-xl text-green-50 leading-relaxed">
              Ready to start your fundraising journey? We're here 24/7 to help you succeed.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Contact Cards */}
      <section className="py-12 -mt-8 relative z-10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">

            <Card className="border-none shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-1 bg-white overflow-hidden group">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">

                  <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-green-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <Mail className="h-7 w-7 text-white" />
                  </div>

                  <div className="flex-1">
                    <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">
                      Email Us
                    </h3>

                    <a
                      href="mailto:info@founderscale.capital"
                      className="text-lg font-bold text-emerald-700 hover:text-emerald-600 transition-colors block"
                      data-testid="contact-email"
                    >
                      info@founderscale.capital
                    </a>

                    <p className="text-sm text-gray-500 mt-1">
                      Response within 24 hours
                    </p>
                  </div>

                </div>
              </CardContent>
            </Card>

            <Card className="border-none shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-1 bg-white overflow-hidden group">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">

                  <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-green-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <Phone className="h-7 w-7 text-white" />
                  </div>

                  <div className="flex-1">
                    <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">
                      Call Us
                    </h3>

                    <a
                      href="tel:+919953022193"
                      className="text-lg font-bold text-emerald-700 hover:text-emerald-600 transition-colors block"
                      data-testid="contact-phone"
                    >
                      +91 99530 22193
                    </a>

                    <p className="text-sm text-gray-500 mt-1">
                      Available 24/7
                    </p>
                  </div>

                </div>
              </CardContent>
            </Card>

          </div>
        </div>
      </section>

      {/* Office Locations */}
      <section className="py-16">
        <div className="container mx-auto px-4">

          <div className="text-center mb-12">
            <span className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 text-xs font-bold uppercase tracking-widest rounded-full mb-4">
              Global Presence
            </span>

            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our{' '}
              <span className="text-emerald-600">
                Offices
              </span>
            </h2>

            <p className="text-xl text-gray-600">
              Three locations. One mission.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">

            {offices.map((office, index) => (
              <Card
                key={index}
                className="border-2 border-gray-100 hover:border-emerald-300 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 group overflow-hidden"
                data-testid={`office-${index}`}
              >

                <div
                  className={`h-2 bg-gradient-to-r ${office.gradient}`}
                ></div>

                <CardContent className="p-8">

                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl">
                      {office.flag}
                    </span>

                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">
                        {office.country}
                      </h3>
                    </div>
                  </div>

                  <div className="flex items-start gap-3 mt-6">
                    <Building className="h-5 w-5 text-emerald-600 mt-0.5 flex-shrink-0" />

                    <p className="text-gray-600 leading-relaxed">
                      {office.address}
                    </p>
                  </div>

                </CardContent>
              </Card>
            ))}

          </div>
        </div>
      </section>

      {/* Contact Form & Calendly */}
      <section className="py-16 bg-gradient-to-br from-slate-50 to-white">
        <div className="container mx-auto px-4">

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">

            <Card className="border-2 border-gray-100 shadow-xl">
              <CardContent className="p-8">

                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                  Send Us a Message
                </h2>

                <p className="text-gray-600 mb-8">
                  Fill out the form below and we'll get back to you within 24 hours.
                </p>

                <form
                  onSubmit={handleSubmit}
                  className="space-y-6"
                  data-testid="contact-form"
                >

                  <div>
                    <Label
                      htmlFor="name"
                      className="text-gray-700 font-semibold mb-2 block"
                    >
                      Your Name *
                    </Label>

                    <Input
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="John Doe"
                      required
                      data-testid="form-name"
                      className="border-gray-300 focus:border-emerald-500 focus:ring-emerald-500"
                    />
                  </div>

                  <div>
                    <Label
                      htmlFor="email"
                      className="text-gray-700 font-semibold mb-2 block"
                    >
                      Email Address *
                    </Label>

                    <Input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@startup.com"
                      required
                      data-testid="form-email"
                      className="border-gray-300 focus:border-emerald-500 focus:ring-emerald-500"
                    />
                  </div>

                  <div>
                    <Label
                      htmlFor="startupName"
                      className="text-gray-700 font-semibold mb-2 block"
                    >
                      Startup Name *
                    </Label>

                    <Input
                      id="startupName"
                      name="startupName"
                      value={formData.startupName}
                      onChange={handleChange}
                      placeholder="Your Startup Inc."
                      required
                      data-testid="form-startup"
                      className="border-gray-300 focus:border-emerald-500 focus:ring-emerald-500"
                    />
                  </div>

                  <div>
                    <Label
                      htmlFor="phone"
                      className="text-gray-700 font-semibold mb-2 block"
                    >
                      Phone Number *
                    </Label>

                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 99530 22193"
                      required
                      data-testid="form-phone"
                      className="border-gray-300 focus:border-emerald-500 focus:ring-emerald-500"
                    />
                  </div>

                  <div>
                    <Label
                      htmlFor="message"
                      className="text-gray-700 font-semibold mb-2 block"
                    >
                      Message *
                    </Label>

                    <Textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your startup and fundraising needs..."
                      required
                      rows={5}
                      data-testid="form-message"
                      className="border-gray-300 focus:border-emerald-500 focus:ring-emerald-500"
                    />
                  </div>

                  <Button
                    type="submit"
                    data-testid="form-submit"
                    disabled={submitting}
                    className="w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:scale-105 disabled:opacity-60"
                  >
                    {submitting ? (
                      <>
                        <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                        Sending...
                      </>
                    ) : (
                      <>
                        Send Message
                        <Send className="ml-2 h-5 w-5" />
                      </>
                    )}
                  </Button>

                </form>
              </CardContent>
            </Card>

            <Card className="border-2 border-emerald-200 shadow-xl bg-gradient-to-br from-emerald-50 to-green-50">
              <CardContent className="p-8">

                <div className="flex items-center gap-3 mb-4">

                  <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-green-600 rounded-xl flex items-center justify-center">
                    <Calendar className="h-6 w-6 text-white" />
                  </div>

                  <h2 className="text-3xl font-bold text-gray-900">
                    Book a Call
                  </h2>

                </div>

                <p className="text-gray-700 mb-6 leading-relaxed">
                  Schedule a free 30-minute consultation. Pick a slot that works for you.
                </p>

                <div className="bg-white rounded-2xl p-8 border-2 border-emerald-200 mb-6">

                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    What to Expect:
                  </h3>

                  <ul className="space-y-3 text-gray-700">

                    <li className="flex items-start gap-2">
                      <span className="text-emerald-600 font-bold">
                        •
                      </span>
                      <span>
                        No-pressure conversation about your fundraising goals
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <span className="text-emerald-600 font-bold">
                        •
                      </span>
                      <span>
                        Honest assessment of whether we can help
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <span className="text-emerald-600 font-bold">
                        •
                      </span>
                      <span>
                        Discussion of your current stage and needs
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <span className="text-emerald-600 font-bold">
                        •
                      </span>
                      <span>
                        Clear next steps if we're a good fit
                      </span>
                    </li>

                  </ul>
                </div>

                <Button
                  onClick={openCalendly}
                  data-testid="calendly-btn"
                  className="w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:scale-105"
                >
                  Schedule Consultation
                  <Calendar className="ml-2 h-5 w-5" />
                </Button>

              </CardContent>
            </Card>

          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-emerald-900 via-emerald-800 to-green-900">

        <div className="container mx-auto px-4 text-center">

          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            We're Always Available
          </h2>

          <p className="text-xl text-green-100 max-w-2xl mx-auto">
            We understand founders don't keep 9-5 hours. Reach out anytime, and we'll respond as quickly as possible.
          </p>

        </div>

      </section>

    </div>
  );
};

export default Contact;
